import React from "react";

export const Alert = ({ children, variant = "default", className = "" }) => {
  const variantStyles = {
    default:
      "bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800",
    destructive:
      "bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800",
    success:
      "bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800",
  };

  return (
    <div
      className={`px-3 py-2 rounded-md text-sm ${variantStyles[variant]} ${className}`}
    >
      {children}
    </div>
  );
};

export const AlertTitle = ({ children, className = "" }) => {
  return <h5 className={`font-medium mb-1 ${className}`}>{children}</h5>;
};

export const AlertDescription = ({ children, className = "" }) => {
  return <div className={`text-sm ${className}`}>{children}</div>;
};
